// consentmo popup
document.addEventListener("DOMContentLoaded", function () {
  var cookieLink = document.getElementById("cookie-preferences"); // no #

  if (cookieLink) {
    cookieLink.addEventListener("click", function (e) {
      e.preventDefault();
      document.dispatchEvent(new CustomEvent("consentmoSignal_openPreferences"));
    });
  }
});


// Country selector
class LocalizationForm extends HTMLElement {
    constructor() {
        super();
        this.elements = {
            input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
            button: this.querySelector('button'),
            panel: this.querySelector('ul'),
        };
        this.elements.button.addEventListener('click', this.openSelector.bind(this));
        this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
        this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

        this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
        this.elements.button.setAttribute('aria-expanded', 'false');
        this.elements.panel.setAttribute('hidden', true);
        document.querySelector(".site-header localization-form").classList.remove('clicked');
    }

    onContainerKeyUp(event) {
        if (event.code.toUpperCase() !== 'ESCAPE') return;

        this.hidePanel();
        this.elements.button.focus();
    }

    onItemClick(event) {
        event.preventDefault();
        const form = this.querySelector('form');
        this.elements.input.value = event.currentTarget.dataset.value;
        if (form) form.submit();
    }

    openSelector() {
        this.elements.button.focus();
        this.elements.panel.toggleAttribute('hidden');
        this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
        const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
        if (event.relatedTarget === null || shouldClose) {
            this.hidePanel();
        }
    }
}

customElements.define('localization-form', LocalizationForm);


// CSS rotate for the localization form down arrow
const downArrow = document.querySelector(".site-header localization-form");
downArrow.addEventListener("click", function () {
    this.classList.toggle("clicked");
});


// Adjust product grid item height
function getInfoSelector(parent) {
    return parent.querySelector('.product-grid-item__info--wrapper')
        ? '.product-grid-item__info--wrapper'
        : '.product-grid-item__info';
}

function setHeight() {
    const parents = document.querySelectorAll('.featured-collection__container');
    parents.forEach(parent => {
        const selector = getInfoSelector(parent);
        const prodGridInfos = parent.querySelectorAll(selector);
        let maxHeight = 0;
        prodGridInfos.forEach(item => {
            item.style.height = 'auto';
            const itemHeight = item.offsetHeight;
            if (itemHeight > maxHeight) {
                maxHeight = itemHeight + 5;
            }
        });
        prodGridInfos.forEach(item => {
            item.style.height = `${maxHeight}px`;
        });
    });
}

function checkAndSetHeight() {
    if (window.innerWidth > 768) {
        setHeight();
    } else {
        const parents = document.querySelectorAll('.featured-collection__container');
        parents.forEach(parent => {
            const selector = getInfoSelector(parent);
            const prodGridInfo = parent.querySelectorAll(selector);
            prodGridInfo.forEach(item => {
                item.style.height = 'auto';
            });
        });
    }
}

document.addEventListener("DOMContentLoaded", function () {
    if (document.querySelector('.featured-collection__container')) {
        checkAndSetHeight();
        window.addEventListener('resize', checkAndSetHeight);
    }
});


// Remove recharge subscription widget and append above add to cart button
/*
$('body').on('DOMNodeInserted', '.rc-container-wrapper', function(){
    $('.rc-container-wrapper').detach().insertBefore(".product__submit__holder"); 
})
*/

// Ingredients showcase section popup toggle
const togglePopup = () => {
    const openBtns = document.querySelectorAll('.IngredientsShowcase-button');
    const ingredientsPopup = document.querySelector('.Offcanvas--ingredients');
    const overlay = document.querySelector('.Offcanvas-bgDimmer');
    const closeBtn = document.querySelector('.IngredientsShowcase-close');
    if(openBtns) {
        openBtns.forEach(btn => {
            btn.addEventListener('click', function() {
                ingredientsPopup.classList.add('is-expanded');
                overlay.classList.add('is-expanded');
                document.body.classList.add('no-scroll-lock');
                document.documentElement.classList.add('no-scroll-lock');
            });
        })
    } 
    if(closeBtn) {
        closeBtn.addEventListener('click', function() {
            ingredientsPopup.classList.remove('is-expanded');
            overlay.classList.remove('is-expanded');
            document.body.classList.remove('no-scroll-lock');
            document.documentElement.classList.remove('no-scroll-lock');
        });
    };
    if(overlay) {
        overlay.addEventListener('click', function() {
            ingredientsPopup.classList.remove('is-expanded');
            overlay.classList.remove('is-expanded');
            document.body.classList.remove('no-scroll-lock');
            document.documentElement.classList.remove('no-scroll-lock');
        });
    };
    document.addEventListener('keydown', function(event) {
        if (event.key === 'Escape') {
            ingredientsPopup.classList.remove('is-expanded');
            overlay.classList.remove('is-expanded');
            document.body.classList.remove('no-scroll-lock');
            document.documentElement.classList.remove('no-scroll-lock');
        }
    });
};
document.addEventListener("DOMContentLoaded", function () {
    if(document.querySelector('.IngredientsShowcase')) {
        togglePopup();
    }
});


// Ingredients showcase description
// jQuery is not loaded on templates that don't use it (see theme.liquid)
if (window.jQuery) {
  jQuery(".IngredientCard-details").hide();

  jQuery(".IngredientCard-image h3").click(function() {
    jQuery(this).hide();
    jQuery(this).next(".overlay").css("opacity",".7");
    jQuery(this).parent().next(".IngredientCard-details").show();
  });

  jQuery(".IngredientCard-details").click(function() {
    jQuery(this).hide();
    jQuery(".overlay").css("opacity",".3");
    jQuery(".IngredientCard-details").hide();
    jQuery(".IngredientCard-image h3").show();
  });
}






// Tabs toggle
// Bundle products summary section
// Bunle routine upsell section
// Look for tab-active class in css file
const tabsToggle = () => {
    const tabCtrs = document.querySelectorAll('.column-item__content-tabs');
    if (!tabCtrs.length) return;
    
    tabCtrs.forEach(ctr => {
        const tabs = ctr.querySelectorAll('.column-item__tab');
        const tabsBody = ctr.querySelectorAll('.column-item__body');
        if(tabs[0] && !tabs[0].classList.contains('tab-active')) {
            tabs[0].classList.add('tab-active');
        }
        if(tabsBody[0] && !tabsBody[0].classList.contains('tab-active')) {
            tabsBody[0].classList.add('tab-active');
        }
        function activeClass(tabId) {
            tabsBody.forEach(body => {
                if (body.getAttribute('data-tab-id') === tabId) {
                    body.classList.add('tab-active');
                } else {
                    body.classList.remove('tab-active');
                }
            });
            tabs.forEach(tab => {
                if (tab.getAttribute('data-tab-id') === tabId) {
                    tab.classList.add('tab-active');
                } else {
                    tab.classList.remove('tab-active');
                }
            });
        }
        tabs.forEach(tab => {
            tab.addEventListener('click', function(event) {
                const tabId = event.currentTarget.getAttribute('data-tab-id');
                activeClass(tabId);
            });
        });
    });
};
window.addEventListener('load', tabsToggle)
if (Shopify.designMode) {
    document.addEventListener("shopify:section:load", function(event) {
        tabsToggle();
    });
}

// Adjust element height bundle products summary
function setHeightBundleSum() {
    const parents = document.querySelectorAll('.bundle-products-summary');
    parents.forEach(parent => {
        const headingPriceCtr = parent.querySelectorAll('.column-item__heading-price');
        let maxHeight = 0;
        headingPriceCtr.forEach(item => {
            item.style.height = 'auto';
            const itemHeight = item.offsetHeight;
            if (itemHeight > maxHeight) {
                maxHeight = itemHeight;
            }
        });
        headingPriceCtr.forEach(item => {
            item.style.height = `${maxHeight}px`;
        });
    });
}

function checkAndSetHeightBundleSum() {
    if (window.innerWidth > 768) {
        setHeightBundleSum();
    } else {
        const ctrs = document.querySelectorAll('.bundle-products-summary .column-item__heading-price');
        ctrs.forEach(item => {
            item.style.height = 'auto';
        });
    };
};
document.addEventListener("DOMContentLoaded", function () {
    if(document.querySelector('.bundle-products-summary')) {
        checkAndSetHeightBundleSum();
        window.addEventListener('resize', checkAndSetHeightBundleSum);
    }
});


// Switch image script
const switchParents = document.querySelectorAll('.switch-image');
switchParents.forEach(switchCtr => {
    const btn = switchCtr.querySelector('.btn--switch');
    const imageOne = document.querySelector('.section-image__container--1');
    const imageTwo = document.querySelector('.section-image__container--2');
    btn.addEventListener('click', () => {
        imageOne.classList.toggle('hide-image');
        imageTwo.classList.toggle('hide-image');
    })
});

// Rewards popup section 
document.addEventListener("DOMContentLoaded", function() {
    var popupSectionCtr = document.getElementById("popupSection");
    var popupCloseButton = document.getElementById("popupCloseButton");
    // Check if the popup has been closed in the current session
    if(popupSectionCtr) {
        var isPopupClosed = sessionStorage.getItem("popupClosed");
        if (!isPopupClosed) {
        // Show the popup
        popupSectionCtr.style.display = "block";
        }
        // Close the popup
        popupCloseButton.addEventListener("click", function() {
            popupSectionCtr.style.display = "none";
            sessionStorage.setItem("popupClosed", true);
        });
    }
});

// Tips & How-To's logic
function tipsHowTo() {
    const tipsOpenBtn = document.querySelectorAll('.tips-popup-open-btn');
    const tipsCloseBtn = document.querySelectorAll('.tips-popup-close-btn');
    tipsOpenBtn.forEach(openBtn => {
        openBtn.addEventListener('click', function() {
            document.querySelector(`.${openBtn.getAttribute("data-card-popup")}-popup`).classList.add('tips-show');
            document.body.classList.add('no-scroll-lock');
            document.documentElement.classList.add('no-scroll-lock');
            setTimeout(() => {
                const prodGridInfos = document.querySelectorAll('.tips-show .section-height-adjust .height-adjust__content');
                let maxHeight = 0;
                prodGridInfos.forEach(item => {
                    item.style.height = 'auto';
                    const itemHeight = item.offsetHeight;
                    if (itemHeight > maxHeight) {
                        maxHeight = itemHeight;
                    }
                });
                prodGridInfos.forEach(item => {
                    item.style.height = `${maxHeight}px`;
                });
            }, 200);
        });
    });
    tipsCloseBtn.forEach(closeBtn => {
        closeBtn.addEventListener('click', function() {
            document.querySelector(`.${closeBtn.getAttribute("data-card-popup")}-popup`).classList.remove('tips-show');
            document.body.classList.remove('no-scroll-lock');
            document.documentElement.classList.remove('no-scroll-lock');
        });
    });
    let howToCarousels = document.querySelectorAll('.js-how-to-custom-carousel');
    howToCarousels.forEach((carousel) => {
    let swiper = new Swiper(carousel, {
        loop: false,
        grabCursor: true,
        slidesPerView: 3.1,
        spaceBetween: 5,
        breakpoints: {
        768: {
            spaceBetween: 10,
            slidesPerView: 3.5,
        }
        }
    });
    });
    let tipsPopupCarousels = document.querySelectorAll('.tip-popup-content__custom .swiper');
        tipsPopupCarousels.forEach((carousel) => {
            let swiper = new Swiper(carousel, {
            loop: false,
            grabCursor: true,
            slidesPerView: 1.05,
            spaceBetween: 8,
            breakpoints: {
                768: {
                    spaceBetween: 10,
                    slidesPerView: 3.5,
                },
                600: {
                    slidesPerView: 2.5
                }
            }
        });
    });
};
window.addEventListener('load', tipsHowTo)
if (Shopify.designMode) {
    document.addEventListener("shopify:section:load", function(event) {
        tipsHowTo();
    });
};

// Adjust height tips & how tos
function setHeightTipsHowTos() {
    setTimeout(() => {
        const prodGridInfos = document.querySelectorAll('.tips-show .section-height-adjust .height-adjust__content');
        let maxHeight = 0;
        prodGridInfos.forEach(item => {
            item.style.height = 'auto';
            const itemHeight = item.offsetHeight;
            if (itemHeight > maxHeight) {
                maxHeight = itemHeight;
            }
        });
        prodGridInfos.forEach(item => {
            item.style.height = `${maxHeight}px`;
        });
    }, 50);
}
document.addEventListener("DOMContentLoaded", function () {
    if(document.querySelector('.section-height-adjust')) {
        setHeightTipsHowTos();
        window.addEventListener('resize', setHeightTipsHowTos);
    }
});

// Blog search functionality
const blogSearchBtn = document.querySelectorAll('.blog-nav__search .search-popdown__toggle');
const blogSearchClsBtn = document.querySelector('.site-header .search-popdown .search-popdown__close .icon');
const searchPopDown = document.querySelectorAll('.site-header .search-popdown details');
blogSearchBtn.forEach(btn => {
    btn.addEventListener('click', function() {
        searchPopDown.forEach(item => {
            item.classList.add('is-open');
            item.setAttribute('open', '');
        });
        if (window.jQuery) $('.search-form input:first-child').after('<input name="type" type="hidden" value="article">');

    });
})
blogSearchClsBtn.addEventListener('click', function() {
    searchPopDown.forEach(item => {
        item.classList.remove('is-open');
        item.removeAttribute('open', '');
    });
    if (window.jQuery) $('.search-form input:first-child').after('<input name="type" type="hidden" value="article">');
});


// Adjust height timeline
function setHeightTimeline() {
    const parents = document.querySelectorAll('.section-columns-timeline');
    parents.forEach(parent => {
        const prodGridInfos = parent.querySelectorAll('.column-item__content');
        let maxHeight = 0;
        prodGridInfos.forEach(item => {
            item.style.height = 'auto';
            const itemHeight = item.offsetHeight;
            if (itemHeight > maxHeight) {
                maxHeight = itemHeight + 5;
            }
        });
        prodGridInfos.forEach(item => {
            item.style.height = `${maxHeight}px`;
        });
    });
}
function checkAndSetHeightTimeline() {
    if (window.innerWidth > 768) {
        setHeightTimeline();
    } else {
        const prodGridInfo = document.querySelectorAll('.section-columns-timeline .column-item__content');
        prodGridInfo.forEach(item => {
            item.style.height = 'auto';
        });
    }
}
document.addEventListener("DOMContentLoaded", function () {
    if(document.querySelector('.section-columns-timeline')) {
        checkAndSetHeightTimeline();
        window.addEventListener('resize', checkAndSetHeightTimeline);
    }
});

var delayInMilliseconds = 2000; //2 second

setTimeout(function() {
  if (!window.jQuery) return;
  $('.section-testimonials-slider .carousel__item').css("height", "100%");
  $('#tangent-temp-div').css("display", "none");
  $('.image-with-text__product').css("position", "absolute");
  $('.image-with-text__product').css("bottom", "0px");
  $('.image-with-text__product').css("width", "100%");
}, delayInMilliseconds);



// rotating text
const guasha_text_slider_init = async function () {
    if (!window.jQuery) return;
    const slideshow = $(".js-guasha-text-slider");

    slideshow.each(function () {
        const carousel = $(this).find(".js-guasha-text-slider-main")[0];
        const speed = $(this).find(".js-guasha-text-slider-speed")[0]?.value;
        let data = {
            delay: 1000 * +speed,
            reverseDirection: true,
            disableOnInteraction: false
        };

        new Swiper(carousel, {
            slidesPerView: 1,
            autoHeight: true,
            direction: "vertical",
            autoplay: data,
            loop: true,
            lazy: {
                loadPrevNext: true
            }
        });
    });
};

guasha_text_slider_init();


// menu script
const menuToggle = () => {
    const menuGrid = document.querySelectorAll('.Menu-grid');
    menuGrid.forEach(grid => {
        const menuBtn = grid.querySelector('.Menu-label');
        const menuInfo = grid.querySelector('.Menu-info');
        menuBtn.addEventListener('click', function() {
            menuInfo.classList.toggle('hide-menu');
            menuInfo.classList.toggle('show-menu');
            menuBtn.classList.toggle('is-expanded');
        });
    });
};
document.addEventListener("DOMContentLoaded", function () {
    if(document.querySelector('.Menu-grid')) {
        menuToggle();;
    }
});


// contact form script
const contact_form_init = async function() {
    if (!window.jQuery) return;
    jQuery("#js-form-main").on("change", function() {
        var _optionSelected_val;
        jQuery(".js-subform").hide();
        jQuery(".js-sub-subform").hide();
        const optionSelected = jQuery(this).find("option:selected");
        const valueSelected = optionSelected.val();
        if (valueSelected !== undefined) {
            const subForm = valueSelected.replace("-select", "");
            jQuery("#js-" + subForm).toggle();
        }
    });

    jQuery("#js-form-order, #js-form-product, #js-form-media").on("change", function() {
        var _subOptionSelected_val;
        jQuery(".js-sub-subform").hide();
        const subOptionSelected = jQuery(this).find("option:selected");
        const subValueSelected = subOptionSelected.val();
        if (subValueSelected === "form-return-select") {
            document.location.href = "https://primallypure.com/pages/returns-exchanges";
        }
        if (subValueSelected !== undefined) {
            const subSubForm = subValueSelected.replace("-select", "");
            jQuery("#js-" + subSubForm).toggle();
        }
    });
};
document.addEventListener("DOMContentLoaded", function () {
    contact_form_init();
});


// Biography grid script
const biographyPopup = () => {
    const cards = document.querySelectorAll('.biography-card');
    const overlay = document.querySelector('#overlay-biography');
    cards.forEach(card => {
        const popup = card.querySelector('.panel');
        const closeBtn = card.querySelector('.card-close-button');
        function openPopup() {
            popup.classList.add('show');
            overlay.classList.add('show');
            document.documentElement.classList.add('no-scroll-lock');
            document.body.classList.add('no-scroll-lock');
        };
        function closePopup() {
            popup.classList.remove('show');
            overlay.classList.remove('show');
            document.documentElement.classList.remove('no-scroll-lock');
            document.body.classList.remove('no-scroll-lock');
        };
        card.addEventListener('click', function() {
            if(!popup.classList.contains('show')) {
                openPopup();
            };
        });
        closeBtn.addEventListener('click', function(event) {
            event.stopPropagation();
            if(popup.classList.contains('show')) {
                closePopup();
            };
        });
        overlay.addEventListener('click', function() {
            if(popup.classList.contains('show')) {
                closePopup();
            };
        });
        document.addEventListener('keydown', function(event) {
            if(event.key === 'Escape') {
                closePopup();
            }
        })
    });
};
document.addEventListener("DOMContentLoaded", function () {
    if(document.querySelector('.section-biography-grid')) {
        biographyPopup();
    };
});
if(Shopify.designMode) {
    document.addEventListener("shopify:section:load", function(event) {
        biographyPopup();
    });
};


/** Rewards click button fix **/

if (window.jQuery) {
  $('#rewardClick').one('click',function() {
    if ($('#rewardClick').text() == "Enrolled! Shop Now!") {
      $(document).delegate(".rewards-btn", "click", function() {
        window.location = $(this).find("a").attr("href");
      });
    }
  });
}


// Product switch script
const product_switch_init_mobile = function() {
    $(".js-product-switch-mobile").off("click").on("click", function() {
        const attr = $(this).attr("attr");
        if ($(this).hasClass("active is-expanded")) {
            $(this).removeClass("active is-expanded");
        } else {
            $(this).addClass("active is-expanded");
        }
        $(".js-product-switch-mobile-block").removeClass("active is-expanded");
        $('.js-product-switch-mobile-block[attr="' + attr + '"]').slideToggle();
    });
};

const product_switch_init_desktop = function() {
    $(".js-product-switch-desktop").on("click", function() {
            const attr = $(this).attr("attr");
            $(".js-product-switch-desktop").removeClass("active");
            $(this).addClass("active");
            $(".js-product-switch-desktop-block").removeClass("active");
            $('.js-product-switch-desktop-block[attr="' + attr + '"]').addClass("active");
    });
};

const initProductSwitch = () => {
    const width = $(window).width();
    if (width < 767) {
        product_switch_init_mobile();
    } else {
        product_switch_init_desktop();
    }
};

if (window.jQuery) {
  $(document).ready(function() {
    $(".js-product-switch-desktop").first().addClass("active");
    $(".js-product-switch-desktop-block").first().addClass("active");
    initProductSwitch();
    $(window).resize(function() {
        initProductSwitch();
    });
  });
}

if(Shopify.designMode) {
    document.addEventListener("shopify:section:load", function(event) {
        product_switch_init();
    });
};


// product media sticky
const prodMediaSticky = () => {
    const headerCtr = document.querySelector('.site-header');
    const prodMedia = document.querySelector('.product-slider-container.sticky-media');
    setTimeout(() => {
        let height = headerCtr.offsetHeight;
        //prodMedia.style.top = '${height + 10}px';
    }, 50);
}

window.addEventListener('resize', prodMediaSticky);


// Image accordion expand mobile images script
const expandMobileImage = () => {
    const images = document.querySelectorAll('.expand-mobile-images .image-accordion');
    images.forEach(image => {
        image.classList.add('constrain-height');
        image.addEventListener('click', function() {
            images.forEach(image => {
                image.classList.remove('expand-height');
            })
            image.classList.add('expand-height');
        })
    })
}
if(Shopify.designMode) {
    document.addEventListener("shopify:section:load", function(event) {
        expandMobileImage();
    });
};
document.addEventListener("DOMContentLoaded", function () {
    if(document.querySelector('.expand-mobile-images')) {
        expandMobileImage();
    };
});


const hideFlickityButtons = () => {
    const prodGallery = document.querySelectorAll('.template-product .product-single .image-slide');
    const buttons = document.querySelectorAll('.template-product .product-single .flickity-button');
    if(prodGallery.length < 2) {
        buttons.forEach(button => {
            button.style.display = 'none';
        });
    };
}
document.addEventListener("DOMContentLoaded", function () {
    if(document.querySelector('.template-product')) {
        hideFlickityButtons();
    };
});


document.addEventListener('DOMContentLoaded', function() {
  const currentUrl = window.location.href;
  const links = document.querySelectorAll('.list-collections__item__outer');

  links.forEach(link => {
    if (link.href === currentUrl) {
      link.classList.add('active'); // Add 'active' class for styling
      // Or: link.style.backgroundColor = 'yellow'; // Change background color
    }
  });
});



const blogIframeHeight = () => {
    const iframes = document.querySelectorAll('.section-article iframe');
    iframes.forEach(iframe => {
        let iframeHeight = iframe.getAttribute('height');
        if(iframeHeight) {
            iframe.style.height = `${iframeHeight}px`;
        }
    });
};
document.addEventListener("DOMContentLoaded", function () {
    if(document.querySelector('.section-article')) {
        blogIframeHeight();
    };
});

window.onload = function() {
    const element = document.querySelector('[data-recipient-checkbox]');
    if (element) {
        element.click();
    }
};

// Blog podcast Spotify modal
const spotifyModal = () => {
    const blogContainer = document.querySelector('.blog-podcasts');
    
    if (!blogContainer) return;
    
    console.log('Spotify modal initialized with event delegation');
    
    const stopAudioAndClose = (post) => {
        const spotifyPopup = post.querySelector('.spotify-modal');
        const iframe = post.querySelector('iframe');
        
        if (spotifyPopup && spotifyPopup.classList.contains('active')) {
            spotifyPopup.classList.remove('active');
            
            if (iframe) {
                iframe.remove();
                spotifyPopup.appendChild(iframe);
            }
        }
    };
    
    const closeAllModals = () => {
        const blogPosts = document.querySelectorAll('.blog-podcasts .blog__post-item');
        blogPosts.forEach(post => {
            stopAudioAndClose(post);
        });
    };
    
    blogContainer.addEventListener('click', (e) => {
        if (e.target.matches('.spotify-popup-btn') || e.target.closest('.spotify-popup-btn')) {
            const spotifyBtn = e.target.closest('.spotify-popup-btn');
            const post = spotifyBtn.closest('.blog__post-item');
            const spotifyPopup = post?.querySelector('.spotify-modal');
            
            if (post && spotifyPopup) {
                closeAllModals();
                
                if (!spotifyPopup.classList.contains('active')) {
                    spotifyPopup.classList.add('active');
                }
            }
        }
        
        if (e.target.matches('.icon-close') || e.target.closest('.icon-close')) {
            const closeBtn = e.target.closest('.icon-close');
            const post = closeBtn.closest('.blog__post-item');
            
            if (post) {
                stopAudioAndClose(post);
            }
        }
    });
};

document.addEventListener("DOMContentLoaded", spotifyModal);

// Blog filter
const blogFilters = () => {
    const blogContainer = document.querySelector('.blog-podcasts');

    if (!blogContainer) return;

    const blogTags = document.querySelectorAll('.blog-podcasts .btn--blog-tag');
    blogTags.forEach(tag => {
        tag.addEventListener('click', async function (event) {
            event.preventDefault();
            const filterTag = this.innerText.toLowerCase();
            const url = window.location.pathname + `?section_id=${sectionId}&tag=${filterTag}`;
            const response = await fetch(url);
            const html = await response.text();
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const newSectionContent = doc.querySelector('.blog__post').innerHTML;
            document.querySelector('.blog__post').innerHTML = newSectionContent;

            const blogGridItems = document.querySelectorAll('.blog-podcasts .blog__post-item-podcast');

            blogTags.forEach(tag => tag.classList.remove('active'));
            if(tag.innerText.toLowerCase() === filterTag) {
                tag.classList.add('active');
            }

            blogGridItems.forEach(item => {
                const dataFilterTags = item.getAttribute('data-filter-tags');
                const tagArr = dataFilterTags.toLowerCase().split(',').map(tag => tag.trim());
                item.style.display = (filterTag === 'most recent' || tagArr.includes(filterTag)) ? 'flex' : 'none';
            })

            const targetY = blogContainer.getBoundingClientRect().top + window.pageYOffset - 150;
            const currentY = window.pageYOffset;

            if (Math.abs(currentY - targetY) < 10) {
                window.scrollBy(0, 1);
                setTimeout(() => window.scrollBy(0, -1), 10);
            } else {
                window.scrollTo({ top: targetY, behavior: 'smooth' });
            }
        })
    })
}
document.addEventListener("DOMContentLoaded", blogFilters);


const resultsLayout = () => {
    // Add page class name found in <body> tag to the pages variable to include this script on additional pages
    // Ex: ('.dry-skin-2026, .example-page-2026')
    const pages = document.querySelectorAll('.dry-skin-2026, .acne-prone-skin-2026, .balanced-skin-2026, .sensitive-skin-2026, .oil-rich-skin-2026');
    if(pages.length < 1) return;
    
    pages.forEach(page => {
        const existingWrapper = page.querySelector('.two-column-wrapper');
        if(existingWrapper) {
            const sections = existingWrapper.querySelectorAll('.shopify-section');
            sections.forEach(section => {
                existingWrapper.parentNode.insertBefore(section, existingWrapper);
            });
            existingWrapper.remove();
        }
        
        const leftSections = page.querySelectorAll('.section-left');
        const rightSections = page.querySelectorAll('.section-right');
        
        if(leftSections.length < 1 && rightSections.length < 1) return;
        
        const leftShopifySections = Array.from(leftSections).map(el => el.closest('.shopify-section'));
        const rightShopifySections = Array.from(rightSections).map(el => el.closest('.shopify-section'));
        
        const firstLeftSection = leftShopifySections[0];
        const firstRightSection = rightShopifySections[0];
        const firstSection = firstLeftSection.compareDocumentPosition(firstRightSection) & Node.DOCUMENT_POSITION_FOLLOWING 
            ? firstLeftSection 
            : firstRightSection;
        
        const parentNode = firstSection.parentNode;
        const referenceNode = firstSection;
        
        const leftCol = document.createElement('div');
        leftCol.className = 'left-column';
        
        const rightCol = document.createElement('div');
        rightCol.className = 'right-column';
        
        const wrapper = document.createElement('div');
        wrapper.className = 'two-column-wrapper results-landing-page';
        wrapper.append(leftCol, rightCol);
        
        parentNode.insertBefore(wrapper, referenceNode);
        
        leftShopifySections.forEach(section => leftCol.appendChild(section));
        rightShopifySections.forEach(section => rightCol.appendChild(section));
    });
}
document.addEventListener('shopify:section:load', resultsLayout);
document.addEventListener('shopify:section:reorder', resultsLayout);
document.addEventListener('shopify:section:select', resultsLayout);
document.addEventListener('shopify:section:deselect', resultsLayout);
document.addEventListener("DOMContentLoaded", resultsLayout);

// Testimonial Slider Height
function setTestimonialHeight() {
    const parents = document.querySelectorAll('.testimonials__wrapper');
    parents.forEach(parent => {
        const testimonialSubheadings = parent.querySelectorAll('.testimonial__subheading--custom');
        let maxHeight = 0;
        testimonialSubheadings.forEach(item => {
            item.style.height = 'auto';
            const itemHeight = item.offsetHeight;
            if (itemHeight > maxHeight) {
                maxHeight = itemHeight + 5;
            }
        });
        testimonialSubheadings.forEach(item => {
            item.style.height = `${maxHeight}px`;
        });
    });
}

function checkAndSetTestimonialHeight() {
    const isThemeEditor = window.self !== window.top;
    
    if (window.innerWidth > 768) {
        setTimeout(function() {
            setTestimonialHeight();
            requestAnimationFrame(function() {
                requestAnimationFrame(function() {
                    window.dispatchEvent(new Event('resize'));
                });
            });
        }, isThemeEditor ? 500 : 100);
    } else {
        const testimonialSubheadings = document.querySelectorAll('.testimonials__wrapper .testimonial__subheading--custom');
        testimonialSubheadings.forEach(item => {
            item.style.height = 'auto';
        });
    }
}

let resizeTimer;
window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
        if(document.querySelector('.testimonials__wrapper')) {
            checkAndSetTestimonialHeight();
        }
    }, 250);
});

document.addEventListener("DOMContentLoaded", function () {
    if(document.querySelector('.testimonials__wrapper')) {
        checkAndSetTestimonialHeight();
    }
});

// Free shipping message update
// Shopify.formatMoney comes from shopify_common.js, which the layouts only load
// on /customers/ pages, so it is absent here. vendor.js is loaded unconditionally
// before this file and exposes the theme's own formatter with the same
// (cents, format) signature -- use that, and degrade quietly if neither exists.
const formatMoneySafe = (cents, format) => {
  const themeFormatMoney = window.themeVendor?.themeCurrency?.formatMoney;

  if (typeof themeFormatMoney === 'function') {
    return themeFormatMoney(cents, format);
  }

  if (typeof window.Shopify?.formatMoney === 'function') {
    return window.Shopify.formatMoney(cents, format);
  }

  return null;
};

const initRebuyShippingProgress = () => {
  const cartMessage = document.querySelector('.announcement-bar-static [data-cart-message]');
  if (!cartMessage) return;

  document.addEventListener('rebuy:cart.change', (event) => {
    const cartTotal = event.detail.cart.cart.total_price;
    const limit = Number(cartMessage.getAttribute('data-limit')) * 100 * window.Shopify.currency.rate;
    const remaining = Math.max(limit - cartTotal, 0);
    const moneyFormat = window.theme.settings.currency_code_enable 
    ? window.theme.moneyWithCurrencyFormat 
    : window.theme.moneyFormat;

    const formatted = formatMoneySafe(remaining, moneyFormat);

    if (formatted !== null) {
      const trimmed = formatted.replace('.00', '').replace(',00', '');

      document.querySelectorAll('[data-left-to-spend]').forEach(el => {
        el.innerHTML = trimmed;
      });
    }

    const isQualified = cartTotal >= limit;
    const isEmpty = cartTotal === 0;

    document.querySelectorAll('[data-cart-message]').forEach(message => {
        const placeholder = message.querySelector('.cart__message__placeholder');
        const defaultMessage = message.querySelector('.cart__message__default');
        const successMessage = message.querySelector('.cart__message__success');

        if (isEmpty) {
            message.classList.remove('is-success');
            placeholder?.style.removeProperty('display');
            defaultMessage?.classList.remove('is-hidden');
            defaultMessage?.style.setProperty('display', 'none');
            successMessage?.style.setProperty('display', 'none');
        } else if (isQualified) {
            message.classList.add('is-success');
            placeholder?.style.setProperty('display', 'none');
            defaultMessage?.classList.remove('is-hidden');
            defaultMessage?.style.setProperty('display', 'none');
            successMessage?.style.removeProperty('display');
        } else {
            message.classList.remove('is-success');
            placeholder?.style.setProperty('display', 'none');
            defaultMessage?.classList.remove('is-hidden');
            defaultMessage?.style.removeProperty('display');
            successMessage?.style.setProperty('display', 'none');
        }
    });
  });
};
document.addEventListener('DOMContentLoaded', initRebuyShippingProgress);

// Swym Wishlist Plus: send shoppers to the wishlist page after adding an item
window.SwymCallbacks = window.SwymCallbacks || [];
window.SwymCallbacks.push(function (swat) {
  swat.evtLayer.addEventListener(swat.JSEvents.addedToWishlist, function () {
    var wishlistPath = '/pages/swym-wishlist';
    if (window.location.pathname.indexOf(wishlistPath) === -1) {
      window.location.href = wishlistPath;
    }
  });
});
